export class Ipo {
    brokerageFirm:string | undefined;
    marketInformation:string | undefined;
    code:string | undefined;
    createDate:string | undefined;
    dateString:string | undefined;
    distributionMethod:string | undefined;
    exchange:string | undefined;
    highPrice:string | undefined;
    lastPrice:string | undefined;
    limit:string | undefined;
    lowPrice:string | undefined;
    name:string | undefined;
    order:string | undefined;
    sharePiece:number;
    shareAdditional:number | undefined;
    startDateString:string | undefined;
    endDateString:string | undefined;
    type:string | undefined;
    lang:string | undefined;
    country:string | undefined;
    url:string | undefined;
    title:string | undefined;
    startDate:Date | undefined;
    endDate:Date | undefined;
    commentCount:number | undefined;

}
